import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/ui/theme-toggle";
import { useAuthStore } from "@/store/auth";
import { useUIStore } from "@/store/ui";
import { LogOut, User, Menu } from "lucide-react";

export function Header() {
  const { user, logout } = useAuthStore();
  const { toggleMobileMenu } = useUIStore();

  const displayName = user?.clientName
    ? `Face : ${user.clientName}`
    : "Face : Internal";

  return (
    <header className="border-b bg-background px-4 md:px-6 py-3 md:py-4">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
        {/* Row 1: Hamburger + Logo + Title */}
        <div className="flex items-center gap-3 w-full md:w-auto">
          <button
            onClick={toggleMobileMenu}
            className="md:hidden min-h-[44px] min-w-[44px] p-2 rounded-md hover:bg-accent touch-manipulation"
            aria-label="Toggle menu"
          >
            <Menu className="h-6 w-6" />
          </button>

          <img
            src="/logo.png"
            alt="FACE Platform"
            className="h-8 w-8 flex-shrink-0"
          />
          <h1 className="text-lg md:text-xl font-semibold text-foreground truncate">
            {displayName}
          </h1>
        </div>

        {/* User info + Actions */}
        <div className="flex items-center gap-3 w-full md:w-auto">
          <div className="flex items-center gap-2 text-sm min-w-0 flex-1">
            <User className="h-4 w-4 text-muted-foreground flex-shrink-0" />
            <span className="font-medium truncate">{user?.name}</span>
            <span className="text-muted-foreground hidden sm:inline truncate">
              ({user?.email})
            </span>
          </div>

          <div className="flex items-center gap-2 flex-shrink-0">
            <ThemeToggle size="sm" />
            <Button
              variant="ghost"
              size="sm"
              onClick={logout}
              className="text-muted-foreground hover:text-foreground min-h-[44px] md:min-h-[36px]"
            >
              <LogOut className="h-4 w-4" />
              <span className="ml-2 hidden sm:inline">Logout</span>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}
